import type { SessionStepDto } from '../../schemas/sessionSchemas';

// Combined Utility Bill Verification step (Electricity / PNG / LPG).
export function isUtilityStep(step: SessionStepDto) {
  return /utility_bill/i.test(step.stepType) || /utility bill/i.test(step.displayName);
}

export type UtilityType = 'electricity' | 'png' | 'lpg';

// Resolve the connection type a session binding represents from its operationId.
export function utilityTypeForBinding(operationId: string): UtilityType | null {
  if (/electricity/i.test(operationId)) return 'electricity';
  if (/png/i.test(operationId)) return 'png';
  if (/lpg/i.test(operationId)) return 'lpg';
  return null;
}

export const UTILITY_TYPE_LABEL: Record<UtilityType, string> = {
  electricity: 'Electricity',
  png: 'PNG Connection',
  lpg: 'LPG',
};

// Electricity / PNG consumer id: 9–13 alphanumeric (matches the gateway rule).
export function isValidConsumerId(v: string): boolean {
  const t = v.trim();
  return /^[a-zA-Z0-9]+$/.test(t) && t.length >= 9 && t.length <= 13;
}

// LPG consumer id: exactly 17 digits (gateway RegexPatterns.LpgId).
export function isValidLpgId(v: string): boolean {
  return /^\d{17}$/.test(v.trim());
}

// Optional registered mobile: blank OR a valid 10-digit Indian mobile.
export function isValidOptionalMobile(v: string): boolean {
  const t = v.trim();
  return t.length === 0 || /^[6-9]\d{9}$/.test(t);
}
